import { WebsiteConfiguration } from '@cineamo/api/models/website-configuration/WebsiteConfiguration.types';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import { getFormattedPhoneAndURI } from '@/helpers/phone-number-helper';

export type FormContactKey = keyof NonNullable<WebsiteConfiguration['forms']>;

/**
 * Resolves the contact phone/email to show on an OUR SERVICES form page: the form-specific
 * `servicePhone`/`serviceEmail` if configured, otherwise the cinema profile's `phone`/`email`.
 */
export const getFormContact = (domainConfiguration: DomainConfigurationDto, formKey: FormContactKey) => {
    const cinema = domainConfiguration.cinema;
    const formConfig = cinema?._embedded?.cinemaConfiguration?.websiteConfiguration?.forms?.[formKey];

    const displayPhone = formConfig?.servicePhone || cinema?.phone;
    const email = formConfig?.serviceEmail || cinema?.email;

    const { formatted: phone, uri: phoneURI } = getFormattedPhoneAndURI(displayPhone);

    return { phone, phoneURI, email };
};
